import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Contact(){
    return (
        <section className="page-section" id="contact">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase">Contact Us</h2>
                    <h6 className="section-heading">
                        carryvilly@gmail.com
                        <br />
                        &copy; {new Date().getFullYear()} CARRYVILLY
                    </h6>
                </div>
            </div>
        </section>
    )
}

export default Contact;